module.exports = __webpack_public_path__ + "img/狂爆风.be0bcf5a.png";